import React from 'react';
import './Maintanence.css';
import { Wrench, AlertTriangle } from 'lucide-react';

const Maintanence = () => {
  return (
    <div className="maintainence-container">
      <div className="maintainence-icon-wrapper">
        <Wrench size={64} strokeWidth={2.5} className="maintainence-icon" />
        <AlertTriangle size={24} strokeWidth={2} className="maintainence-alert" />
      </div>
      <h1 className="maintainence-heading">We'll be back soon!</h1>
      <p className="maintainence-message">
        Our website is currently undergoing scheduled maintenance. <br />
        Thank you for your patience.
      </p>
      <div className="maintainence-footer">
        &copy; {new Date().getFullYear()} Dabler. All rights reserved.
      </div>
    </div>
  );
};

export default Maintanence;
